import axios from 'axios';

import { API_CONFIG } from 'constants/config';
import { handleErrors } from 'utils/api';
import { CATEGORIZE_EMAIL, CATEGORIZE_EMAIL_BULK } from 'constants/analytics';
import { analyticsTrack } from '../../utils/analytics';

// object
export const GET_OUTREACH_PENDING = 'GET_OUTREACH_PENDING';
export const GET_OUTREACH_FAIL = 'GET_OUTREACH_FAIL';
export const GET_OUTREACH_SUCCESS = 'GET_OUTREACH_SUCCESS';
export const UPDATE_OUTREACH_PENDING = 'UPDATE_OUTREACH_PENDING';
export const UPDATE_OUTREACH_FAIL = 'UPDATE_OUTREACH_FAIL';
export const UPDATE_OUTREACH_SUCCESS = 'UPDATE_OUTREACH_SUCCESS';
export const UPDATE_OUTREACH_STATUS = 'UPDATE_OUTREACH_STATUS';
export const SET_OUTREACH = 'SET_OUTREACH';
export const UPDATE_OUTREACH_STATUS_BULK = 'UPDATE_OUTREACH_STATUS_BULK';
export const UPDATE_OUTREACH_READ_BULK = 'UPDATE_OUTREACH_READ_BULK';
export const UPDATE_OUTREACH_IS_READ = 'UPDATE_OUTREACH_IS_READ';
export const DESTROY_OUTREACH_PENDING = 'DESTROY_OUTREACH_PENDING';
export const DESTROY_OUTREACH_FAIL = 'DESTROY_OUTREACH_FAIL';
export const DESTROY_OUTREACH_SUCCESS = 'DESTROY_OUTREACH_SUCCESS';
// objects
export const GET_OUTREACHES_PENDING = 'GET_OUTREACHES_PENDING';
export const GET_OUTREACHES_FAIL = 'GET_OUTREACHES_FAIL';
export const GET_OUTREACHES_SUCCESS = 'GET_OUTREACHES_SUCCESS';
export const UPDATE_BULK_OUTREACHES_PENDING = 'UPDATE_BULK_OUTREACHES_PENDING';
export const UPDATE_BULK_OUTREACHES_FAIL = 'UPDATE_BULK_OUTREACHES_FAIL';
export const UPDATE_BULK_OUTREACHES_SUCCESS = 'UPDATE_BULK_OUTREACHES_SUCCESS';


export const setOutreach = outreachObj => async (dispatch) => {
  dispatch({
    type: SET_OUTREACH,
    payload: {
      ...outreachObj,
    },
  });
};


export const getOutreach = (outreachId, seamless = false) => async (dispatch) => {
  dispatch({
    type: GET_OUTREACH_PENDING,
    payload: seamless ? { loading: false, loaded: true } : {},
  });
  try {
    dispatch({
      type: UPDATE_OUTREACH_IS_READ,
      payload: { id: outreachId },
    });
    const response = await axios.get(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}outreaches/${outreachId}/`,
      { withCredentials: true },
    );
    dispatch({
      type: GET_OUTREACH_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const getOutreaches = (
  params = {
    statuses: null,
    account__id: null,
    campaign__id: null,
    end_date: null,
    start_date: null,
    campaign__campaign_manager__id: null,
    page: null,
  },
  seamless = false,
) => async (dispatch) => {
  dispatch({
    type: GET_OUTREACHES_PENDING,
    payload: seamless ? { ...params, loading: false, loaded: true } : params,
  });
  const fetchUrl = `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}outreaches/`;

  try {
    const paramsCopy = { ...params };
    delete paramsCopy.statuses;
    const urlEncodedParams = new URLSearchParams(paramsCopy);
    params.statuses.forEach(status => urlEncodedParams.append('statuses', status));

    const response = await axios.get(`${fetchUrl}`, { params: urlEncodedParams, withCredentials: true });
    dispatch({
      type: GET_OUTREACHES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const updateOutreachThreadStatus = (
  outreachId,
  params = {
    thread_status: null,
  },
  seamless = false,
) => async (dispatch) => {
  const payload = {
    id: outreachId,
    newStatus: params.thread_status,
  };
  analyticsTrack(CATEGORIZE_EMAIL, payload, true);
  dispatch({
    type: UPDATE_OUTREACH_STATUS,
    payload,
  });
  dispatch({
    type: UPDATE_OUTREACH_PENDING,
    // we've disabled loading if 'seamless' option is present because we need seamless inline editing
    payload: seamless ? { ...params, loading: false, loaded: true } : params,
  });
  try {
    const response = await axios.post(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}outreaches/${outreachId}/change-status/`,
      params,
      { withCredentials: true },
    );
    dispatch({
      type: UPDATE_OUTREACH_SUCCESS,
      // and this will ensure that data is in sync with backend
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const updateOutreachThreadStatusBulk = (params = [], seamless = false) => async (dispatch) => {
  dispatch({
    type: UPDATE_BULK_OUTREACHES_PENDING,
    // we've disabled loading if 'seamless' option is present because we need seamless inline editing
    payload: seamless ? { ...params, loading: false, loaded: true } : params,
  });
  const payload = {
    ids: params.map(o => o.id),
    newStatus: params[0].thread_status,
  };
  analyticsTrack(CATEGORIZE_EMAIL_BULK, payload, true);
  try {
    dispatch({
      type: UPDATE_OUTREACH_STATUS_BULK,
      payload,
    });
    await axios.post(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}outreaches/change-status/`,
      params,
      { withCredentials: true },
    );
    dispatch({
      type: UPDATE_BULK_OUTREACHES_SUCCESS,
      payload: {
        ids: params.map(o => o.id),
        newStatus: params[0].thread_status,
      },
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const setOutreachAsReadBulk = (params = [], seamless = false) => async (dispatch) => {
  dispatch({
    type: UPDATE_BULK_OUTREACHES_PENDING,
    // we've disabled loading if 'seamless' option is present because we need seamless inline editing
    payload: seamless ? { ...params, loading: false, loaded: true } : params,
  });
  try {
    dispatch({
      type: UPDATE_OUTREACH_READ_BULK,
      payload: {
        ids: params.map(o => o.id),
      },
    });
    await axios.post(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}outreaches/mark-read/`,
      params,
      { withCredentials: true },
    );
    dispatch({
      type: UPDATE_BULK_OUTREACHES_SUCCESS,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const destroyBulkOutreach = outreachIds => async (dispatch) => {
  try {
    await axios.delete(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}outreaches/bulk/`,
      { withCredentials: true, data: outreachIds },
    );
  } catch (error) {
    handleErrors(error, dispatch);
  }
};
